import { render, staticRenderFns } from "./Manage_device.vue?vue&type=template&id=3876c4a2&"
import script from "./Manage_device.vue?vue&type=script&lang=js&"
export * from "./Manage_device.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports